import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import {useTheme} from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import '../../../scss/components/_fullScreen.scss';
import API_PATH from "../../../constants/config.json";
import FileList from '../../StationDetails/FileList';
import NoDetails from '../../StationDetails/NoDetails';
import StationCard from '../../StationDetails/Intersection/StationCard';
import DetailsCard from '../../StationDetails/Intersection/DetailsCard';
import Turning from '../../StationDetails/Intersection/Turning';
import Trunk from '../../StationDetails/Intersection/Trunk';
import Pedestrian from '../../StationDetails/Intersection/Pedestrian';
import Cycle from '../../StationDetails/Intersection/Cycle';
import DataVehicles from '../../StationDetails/Intersection/DataVehicles';
import Cookies from 'js-cookie';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import ReactEcharts from 'echarts-for-react';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {getIntersectionDatePeakData,getIntersentionRecentYear,getIntersectionTurningMovement,getIntersectionTruckPercentage,getIntersectionPedestrianMovement,getIntersectionBicycleMovement,getIntersectionBicycleCrosswalkMovement} from '../../../components_v2/Information/IntersectionGetData';
import { loadModules } from 'esri-loader';
import {isLogin} from '../../../functions/Auth';
import ExportData from '../../../components_v2/DataFilter/ExportData';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import HomeIcon from '@material-ui/icons/Home';
import Modal from '@material-ui/core/Modal';
import ExportDataDetails from '../ExportDataDetails';
import HelpDisk from '../../Information/HelpDisk';  
import SignalPlanning from '../SignalPlanning/SignalPlanning';
import CreateScenario from '../SignalPlanning/CreateScenario';
import DeleteScenario from '../SignalPlanning/DeleteScenario';
import LaneGeometry from '../../DataManagement/LaneGeometry';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const queryString = require('query-string');

let _intersectionChecked
let _midblockChecked


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  

const FullScreen = props => {
    let history = useHistory();
    const theme = useTheme();
    const mapRef = useRef();  
    React.useEffect(
        () => {     
          if (props.location) {
            const parsed = queryString.parse(props.location.search);            
            if (parsed && parsed.station) { 
              let sharedAgency = (parsed.by)?parsed.by : false;               
              getStationId(parsed.station,sharedAgency);
            } else {
                window.location.href = '/UsersDashboard';
            }
          }          
        }, []
    );
    
    let turingImgSrc = require(".././../../assets/images/turning.svg");   
    let trackImage = require(".././../../assets/images/truck.svg");
    let bicycleImage = require(".././../../assets/images/cycle.svg");
    let pedestrianImage = require(".././../../assets/images/Walk.svg");

    const [stationID, setStationID] = React.useState(null);
    const [stationData, setStationData] = React.useState(null);
    const [hasData, setHasData] = React.useState(false);
    const [turningCountDate, setTurningCountDate] = React.useState(null);
    const [pedestrianCountDate, setPedestrianCountDate] = React.useState(null);
    const [biCycleCountDate, setBiCycleCountDate] = React.useState(null);

    const [peakDate, setPeakDate] = React.useState([]);
    const [dateVal, setDateVal] = React.useState(null);
    const [peakData, setPeakData] = React.useState(null);

    const [amHasData, setAmHasData] = React.useState(null);
    const [midHasData, setMidHasData] = React.useState(null);
    const [pmHasData, setPmHasData] = React.useState(null);     
    const [selectedDate, setSelectedDate] = React.useState(null); 

    const [AMdata, setAMdata] = React.useState(null);
    const [MIDdata, setMIDdata] = React.useState(null);
    const [PMdata, setPMdata] = React.useState(null);
    const [timePeriod, setTimePeriod] = React.useState(null);

    const [movementData, setMovementData] = React.useState(null);  
    const [turningCountData, setTurningCountData] = React.useState([]);
    const [truckCountData, setTruckCountData] = React.useState([]);
    const [pedestrianData, setPedestrianData] = React.useState([]);
    const [bicycleCountData, setBicycleCountData] = React.useState([]);
    const [bicycleCrosswalkCountData, setBicycleCrosswalkCountData] = React.useState([]);

    const [startPeakHour, setStartPeakHour] = React.useState(null);
    const [endPeakHour, setEndPeakHour] = React.useState(null);
    const [startPeakMin, setStartPeakMin] = React.useState(null);
    const [endPeakMin, setEndPeakMin] = React.useState(null);    

    const [myOptions, setmyOptions] = React.useState({})    
    const [getResponseData, setResponseData] = React.useState({})
    const [getResponseApproches, setResponseApproches] = React.useState([]);
    const [getDashedArray, setDashedArray] = React.useState([]);

    const [stationList, setStationList] = React.useState([]);  
    const [getLoader, setLoaderDisable] = React.useState(false);
    const [totalItems, setTotalItems] = React.useState(0);
    const [userAccess, setUserAccess] = React.useState(true);
    
    const [exportChecked, setExportChecked] = React.useState('none');
    const [midblockChecked, setMidblockChecked] = React.useState(false);
    const [intersectionChecked, setIntersectionChecked] = React.useState(false);
    const [multipleStationId, setMutipleStationId] = React.useState([]);
    const [singleMidblockStationId, setSingleMidblockStationId] = React.useState([]);
    const [singleIntersectionStationId, setSingleIntersectionStationId] = React.useState([]);

    const [sharedStation,setSharedStation] = React.useState(false);
    const [sharedAgencyName,setSharedAgencyName] = React.useState(false);
    const [zoom, setZoom] = React.useState(null);

    const [showLoader,setShowLoader]=React.useState(false)

    const [showNewScenario,setShowNewScenario]=React.useState(false)
    const [reloadScenarios,setReloadScenarios]=React.useState(true);
    const [showDeleteScenario,setShowDeleteScenario]=React.useState(false);
    const [newScenarioId, setNewScenarioId] = React.useState(null);
    const [scenarioToDelete, setScenarioToDelete] = React.useState(null);
    const [showLaneConfig, setShowLaneConfig] = React.useState(false);


    const [sb_approach, setSb_approach] = React.useState("");
    const [wb_approach, setWb_approach] = React.useState("");
    const [nb_approach, setNb_approach] = React.useState("");
    const [eb_approach, setEb_approach] = React.useState("");

    let enteriesPerPage = 50;
    const [tabValue, setTabValue] = React.useState(0);
    const handleChangeTab = (event, newValue) => {
      if(newValue == 0){
        loadMap();
      }
      setTabValue(newValue);
      if(newValue === 2) {
        setReloadScenarios(true);
      }
    };
    const exportpopUp = () => {
    
      if (exportChecked == 'none') {
        setExportChecked('block');
      }
      else {
        setExportChecked('none');
        //setMutipleStationId([]);
      }
    }
    useEffect(
      () => { 
        if( truckCountData){
          setShowLoader(false)
        }
        
             }, [turningCountData,truckCountData]) 
    const getStationId = (id,agency=false) => {
        try {
          axios({
            method: 'post',
            data: {
              "clientStationId": id,
              "sharedby":agency
            },
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + API_PATH.getStationId
          }).then(function (response) {            
            if (response && response.data && response.data.data && response.data.data.length > 0) {
              const stationId = response.data.data[0].station_id;
              setStationID(stationId);
              getStationDetail(stationId)
            } else {
                window.location.href = '/UsersDashboard';
            }
          })
        }
        catch (error) {
          // Throw the error
        }
    }
    const getStationDetail = (station_id) => {          
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getStationDetail + station_id,
            }).then(async function (response) {  
                let data = response.data.data; 
                //streets
                setSb_approach(data.sb_approach);
                setWb_approach(data.wb_approach);
                setNb_approach(data.nb_approach);
                setEb_approach(data.eb_approach);
                let startPeak = null;
                setStationData(data)  

                //review shared
                let shared = (data.is_shared && data.FK_agency_id != sessionStorage.getItem('agency_id'))?true : false;
                let sharedBy = (shared)?data.agency : '';
                setSharedStation(shared);
                setSharedAgencyName(sharedBy);
                //
                //get information 
                let intersentionRecentYear = await getIntersentionRecentYear(station_id); 
                let intersectionHasData = (intersentionRecentYear.length !=0 && (intersentionRecentYear.turningyear !='' || intersentionRecentYear.pedestrianyear !='' || intersentionRecentYear.bicycleyear !=''))?true : false;                         
                if(intersectionHasData){                          
                  let intersectionDatePeakData = await getIntersectionDatePeakData(station_id);            
                    let intersectionTurningMovement = await getIntersectionTurningMovement(intersectionDatePeakData.timeData,station_id);            
                    let intersectionTruckPercentage = await getIntersectionTruckPercentage(intersectionDatePeakData.timeData,station_id);            
                    let intersectionPedestrianMovement = await getIntersectionPedestrianMovement(intersectionDatePeakData.timeData,station_id);            
                    let intersectionBicycleMovement = await getIntersectionBicycleMovement(intersectionDatePeakData.timeData,station_id);                                        
                    let intersectionBicycleCrosswalkMovement = await getIntersectionBicycleCrosswalkMovement(intersectionDatePeakData.timeData,station_id);                                        
                    
                    setTurningCountDate(intersentionRecentYear.hasOwnProperty('turningyear')?intersentionRecentYear.turningyear:null);
                    setPedestrianCountDate(intersentionRecentYear.hasOwnProperty('pedestrianyear')?intersentionRecentYear.pedestrianyear:null);
                    setBiCycleCountDate(intersentionRecentYear.hasOwnProperty('bicycleyear')?intersentionRecentYear.bicycleyear:null);
                    setPeakDate(intersectionDatePeakData.hasOwnProperty('peakDate')?intersectionDatePeakData.peakDate:[]);
                    setDateVal(intersectionDatePeakData.hasOwnProperty('dateVal')?intersectionDatePeakData.dateVal:null);
                    setPeakData(intersectionDatePeakData.hasOwnProperty('peakData')?intersectionDatePeakData.peakData:null);

                    setSelectedDate(intersectionDatePeakData.hasOwnProperty('selectedDate')?intersectionDatePeakData.selectedDate:null);
                    setAmHasData(intersectionDatePeakData.hasOwnProperty('AmHasData')?intersectionDatePeakData.AmHasData:[]);
                    setMidHasData(intersectionDatePeakData.hasOwnProperty('MidHasData')?intersectionDatePeakData.MidHasData:[]);
                    setPmHasData(intersectionDatePeakData.hasOwnProperty('PmHasData')?intersectionDatePeakData.PmHasData:[]);
           
                    setAMdata(intersectionDatePeakData.hasOwnProperty('AMdata')?intersectionDatePeakData.AMdata:null);          
                    setMIDdata(intersectionDatePeakData.hasOwnProperty('MIDdata')?intersectionDatePeakData.MIDdata:null);
                    setPMdata(intersectionDatePeakData.hasOwnProperty('PMdata')?intersectionDatePeakData.PMdata:null); 

                    if(startPeak == null){
                        setStartPeakHour(intersectionDatePeakData.hasOwnProperty('AMdata') && intersectionDatePeakData.AMdata.hasOwnProperty('hour')?intersectionDatePeakData.AMdata.hour.startdate:null);
                        setEndPeakHour(intersectionDatePeakData.hasOwnProperty('AMdata') && intersectionDatePeakData.AMdata.hasOwnProperty('hour')?intersectionDatePeakData.AMdata.hour.enddate:null);          
                        setStartPeakMin(intersectionDatePeakData.hasOwnProperty('AMdata') && intersectionDatePeakData.AMdata.hasOwnProperty('minute')?intersectionDatePeakData.AMdata.minute.startdate:null);
                        setEndPeakMin(intersectionDatePeakData.hasOwnProperty('AMdata') && intersectionDatePeakData.AMdata.hasOwnProperty('minute')?intersectionDatePeakData.AMdata.minute.enddate:null);
                        startPeak = (intersectionDatePeakData.hasOwnProperty('AMdata'))?intersectionDatePeakData.AMdata:null;
                    }  

                    if(startPeak == null){
                        setStartPeakHour(intersectionDatePeakData.hasOwnProperty('MIDdata') && intersectionDatePeakData.MIDdata.hasOwnProperty('hour')?intersectionDatePeakData.MIDdata.hour.startdate:null);
                        setEndPeakHour(intersectionDatePeakData.hasOwnProperty('MIDdata') && intersectionDatePeakData.MIDdata.hasOwnProperty('hour')?intersectionDatePeakData.MIDdata.hour.enddate:null);
                        setStartPeakMin(intersectionDatePeakData.hasOwnProperty('MIDdata') && intersectionDatePeakData.MIDdata.hasOwnProperty('minute')?intersectionDatePeakData.MIDdata.minute.startdate:null);
                        setEndPeakMin(intersectionDatePeakData.hasOwnProperty('MIDdata') && intersectionDatePeakData.MIDdata.hasOwnProperty('minute')?intersectionDatePeakData.MIDdata.minute.enddate:null);
                        startPeak = (intersectionDatePeakData.hasOwnProperty('MIDdata'))?intersectionDatePeakData.MIDdata:null;
                    }

                    if(startPeak == null){
                        setStartPeakHour(intersectionDatePeakData.hasOwnProperty('PMdata') && intersectionDatePeakData.PMdata.hasOwnProperty('hour')?intersectionDatePeakData.PMdata.hour.startdate:null);
                        setEndPeakHour(intersectionDatePeakData.hasOwnProperty('PMdata') && intersectionDatePeakData.PMdata.hasOwnProperty('hour')?intersectionDatePeakData.PMdata.hour.enddate:null);
                        setStartPeakMin(intersectionDatePeakData.hasOwnProperty('PMdata') && intersectionDatePeakData.PMdata.hasOwnProperty('minute')?intersectionDatePeakData.PMdata.minute.startdate:null);
                        setEndPeakMin(intersectionDatePeakData.hasOwnProperty('PMdata') && intersectionDatePeakData.PMdata.hasOwnProperty('minute')?intersectionDatePeakData.PMdata.minute.enddate:null);
                        startPeak = (intersectionDatePeakData.hasOwnProperty('PMdata'))?intersectionDatePeakData.PMdata:null;

                    }
                    setTimePeriod(intersectionDatePeakData.hasOwnProperty('timePeriod')?intersectionDatePeakData.timePeriod:null);

                    setTurningCountData(intersectionTurningMovement);
                    setTruckCountData(intersectionTruckPercentage);
                    setPedestrianData(intersectionPedestrianMovement);
                    setBicycleCountData(intersectionBicycleMovement);
                    setBicycleCrosswalkCountData(intersectionBicycleCrosswalkMovement);
                    
                    // time period validation 
                    if(intersectionDatePeakData.hasOwnProperty('timePeriod')) {
                      let timep = intersectionDatePeakData.timePeriod;
                      if(timep === "PM" ) {
                        setStartPeakHour(intersectionDatePeakData.hasOwnProperty('PMdata') && intersectionDatePeakData.PMdata.hasOwnProperty('hour')?intersectionDatePeakData.PMdata.hour.startdate:null);
                        setEndPeakHour(intersectionDatePeakData.hasOwnProperty('PMdata') && intersectionDatePeakData.PMdata.hasOwnProperty('hour')?intersectionDatePeakData.PMdata.hour.enddate:null);
                        setStartPeakMin(intersectionDatePeakData.hasOwnProperty('PMdata') && intersectionDatePeakData.PMdata.hasOwnProperty('minute')?intersectionDatePeakData.PMdata.minute.startdate:null);
                        setEndPeakMin(intersectionDatePeakData.hasOwnProperty('PMdata') && intersectionDatePeakData.PMdata.hasOwnProperty('minute')?intersectionDatePeakData.PMdata.minute.enddate:null);
                        startPeak = (intersectionDatePeakData.hasOwnProperty('PMdata'))?intersectionDatePeakData.PMdata:null;
                      } else if (timep === "MID") {
                        setStartPeakHour(intersectionDatePeakData.hasOwnProperty('MIDdata') && intersectionDatePeakData.MIDdata.hasOwnProperty('hour')?intersectionDatePeakData.MIDdata.hour.startdate:null);
                        setEndPeakHour(intersectionDatePeakData.hasOwnProperty('MIDdata') && intersectionDatePeakData.MIDdata.hasOwnProperty('hour')?intersectionDatePeakData.MIDdata.hour.enddate:null);
                        setStartPeakMin(intersectionDatePeakData.hasOwnProperty('MIDdata') && intersectionDatePeakData.MIDdata.hasOwnProperty('minute')?intersectionDatePeakData.MIDdata.minute.startdate:null);
                        setEndPeakMin(intersectionDatePeakData.hasOwnProperty('MIDdata') && intersectionDatePeakData.MIDdata.hasOwnProperty('minute')?intersectionDatePeakData.MIDdata.minute.enddate:null);
                        startPeak = (intersectionDatePeakData.hasOwnProperty('MIDdata'))?intersectionDatePeakData.MIDdata:null;
                      }
                    }
                }  
                setHasData(intersectionHasData);   
                loadMap(data,intersectionHasData,shared);
                getFileList(station_id);

                //review time has data             
                if(intersectionHasData){        
                    getIntersectionTrafficData(startPeak,station_id);
                }                     
            })
            .catch(function (error) {
                console.log(error);
            })
        } catch (error) {
          console.error(error);
        }
    }
    const getCurrentDataTime = () =>{
        let dataPeriod = null;
        let dataTime = null;

          if(!dataPeriod && AMdata.count){
            dataPeriod = 'AM';    
            dataTime =  AMdata;
          }
          if(!dataPeriod && MIDdata.count){
            dataPeriod = 'MID';    
            dataTime =  MIDdata;
          }
          if(!dataPeriod && PMdata.count){
            dataPeriod = 'PM';    
            dataTime =  PMdata;
          } 
  
          return dataTime;
      }
    const loadMap = (data = null,hasDataInfo=null,shared=null) => {
        // lazy load the required ArcGIS API for JavaScript modules and CSS
        hasDataInfo = (hasDataInfo != null)?hasDataInfo : hasData;
        loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic", "esri/layers/GraphicsLayer", "esri/symbols/PictureMarkerSymbol", "esri/widgets/Search"], { css: true })
          .then(async ([ArcGISMap, MapView, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, GraphicsLayer, PictureMarkerSymbol, Search]) => {
            const map = new ArcGISMap({
              basemap: (sessionStorage.getItem('baseMapType') !=null && sessionStorage.getItem('baseMapType') =='hybrid')?'hybrid':'streets-navigation-vector',
              slider: false
            });        
            let view = new MapView({
              container: mapRef.current,
              map: map,
              ui: {
                components: ['home', 'locate'] // specify only the components you want
              },
            });
            let zoom = new Zoom({
              view: view,
            });
            let featureLayer = new FeatureLayer({
              url: sessionStorage.getItem('mapURL')
            });
            featureLayer.when(function () { // adds feature layer to map view
              let vp = new Viewpoint({
                targetGeometry: featureLayer.fullExtent
              });
              view.extent = featureLayer.fullExtent;
    
            });
            map.add(featureLayer);
            setZoom(zoom);
            //let position = await getStationDetails();
            let lng = (data != null)?data.longitude : stationData.longitude;
            let lat = (data != null)?data.latitude : stationData.latitude;
            shared = (shared != null)?shared : sharedStation;
            featureLayer.when(async function () { // adds feature layer to map view         
              // console.log('Logn :'+longitude+ 'Lat :'+latitude);          
              let point = new Point(lng, lat);          
              let pointSymbol = {
                type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                url: shared?require("../../../assets/icons/marker_Intersection_shared.png"):require("../../../assets/icons/marker_Intersection.png"),
                width: "34px",
                height: "34px",
                yoffset: "20px"
              }
              let pointGraphic = new Graphic(point, pointSymbol);
              view.graphics.add(pointGraphic);
              view.goTo(pointGraphic).then(function () {
                view.zoom = view.zoom + 5;
                if(!hasDataInfo){
                    //view.graphics.remove(pointGraphic);
                  }
              });
            });
    
          });
        }
    const getFileList = (station_id=null) => { // API call to get all files
        setLoaderDisable(true);
        try {
          axios({
            method: 'post',
            data: {
              stationId: (station_id!=null)? station_id : stationID,
              pageNo: 1,
              entriesPerPage: enteriesPerPage
            },
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + API_PATH.fileList,
          })
            .then(async function (response) {            
              if (response.status && response.status == '200') {
                setLoaderDisable(false);
                setStationList(response.data.data.rows);
                setTotalItems(response.data.data.count);
              } else {
                setStationList([]);
                setLoaderDisable(false);
              }
            })
            .catch(function (error) {
              if (error.response) {
                if (error.response.data.status == 403) {
                  setUserAccess(false);
                  setLoaderDisable(false);
                  setStationList([]);
                } else {
                  setStationList([]);
                  setLoaderDisable(false);
                }
              } else {
                setStationList([]);
                setLoaderDisable(false);
              }
            })
        } catch (error) {
          console.error(error);
          setLoaderDisable(false);
        }
      }
    const onTimePeriorodChange = (e) =>{          
        setTimePeriod(e.target.value);
        reviewTimePeriod(e.target.value);           
    } 
    const reviewTimePeriod = (value,dataTime=null) =>{
        //set new data to diagram
        let data = null;
        if(value == "AM"){
          data = (dataTime != null)?dataTime:AMdata;
        }
        if(value == "MID"){
          data = (dataTime != null)?dataTime:MIDdata;
        }
        if(value == "PM"){
          data = (dataTime != null)?dataTime:PMdata;
        }       
        setStartPeakHour(data.hour.startdate);
        setEndPeakHour(data.hour.enddate);          
        setStartPeakMin(data.minute.startdate);
        setEndPeakMin(data.minute.enddate); 
        updateMovementData(data);
        if(isLogin){        
          getIntersectionTrafficData(data);
        } 
      }
      const updateMovementData = async (data) => {
        setShowLoader(true)
        setMovementData(true);
        setTurningCountData(await getIntersectionTurningMovement(data,stationID));
        setTruckCountData(await getIntersectionTruckPercentage(data,stationID));
        setPedestrianData(await getIntersectionPedestrianMovement(data,stationID));
        setBicycleCountData(await getIntersectionBicycleMovement(data,stationID));
        setBicycleCrosswalkCountData(await getIntersectionBicycleCrosswalkMovement(data,stationID));
      }
      const onDateChange = (e) => {          
        setSelectedDate(e.target.value);
        let dataPeriod = null;
        let dataTime = null;
        peakData && peakData.length > 0 && peakData.map((val) => {
          if (val.date == e.target.value) {            
            if (val.am) {
              setAMdata(val.am);     
              setAmHasData((val.am.count == 0)?true : false);          
            }
            if (val.mid) {
              setMIDdata(val.mid);
              setMidHasData((val.mid.count == 0)?true : false);
            }
            if (val.pm) {
              setPMdata(val.pm);
              setPmHasData((val.pm.count == 0)?true : false);
            }
            
            if(!dataPeriod && val.am.count){
              dataPeriod = 'AM';    
              dataTime =  val.am;              
            }
            if(!dataPeriod && val.mid.count){
              dataPeriod = 'MID';   
              dataTime =  val.mid;         
            }
            if(!dataPeriod && val.pm.count){
              dataPeriod = 'PM';    
              dataTime =  val.pm;        
            }
            setTimePeriod(dataPeriod);            
          }
        })             
        
        reviewTimePeriod(dataPeriod,dataTime);               
      }
      const getIntersectionTrafficData = async(time, station_id=null) => {
        let id = (station_id!=null)?station_id : stationID;
        try {
         await axios({
            method: 'post',
            url: API_URL + API_PATH.getIntersectionTrafficData,
            data: {
              stationId: id,
              startdate: time.startdate,
              enddate: time.enddate
            },
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
          }).then(function (response) {
            if (response && (response.data.data && response.data.approaches)) {
              setResponseData(response.data.data);
              setResponseApproches(response.data.approaches);            
              let northGraph = [];
              let southGraph = [];
              let eastGraph = [];
              let westGraph = [];
              let dateTimeArray = [];
              let dashedArray = [];
    
              response.data.data.map((ele, index) => {
                dateTimeArray.push(ele.starttime)
                northGraph.push(ele.north.sum);
                southGraph.push(ele.south.sum);
                eastGraph.push(ele.east.sum);
                westGraph.push(ele.west.sum);
                dashedArray.push(checkCondition(ele.north, ele.east, ele.west, ele.south))
              })
    
    
              setDashedArray(dashedArray);
              myOptionFunction(northGraph, southGraph, eastGraph, westGraph, dateTimeArray);
    
            } else {
              setResponseData({});          
            }
          }).catch((err) => {       
            setResponseData({});
          })
    
        }
        catch (error) {
          setResponseData({});      
        }
      } 
      const checkCondition = (north, east, west, south) => {
        let checkArray = [];
        Object.values(north).map((obj, index) => {
          checkArray.push(obj);
        })
        Object.values(east).map((obj, index) => {
          checkArray.push(obj);
        })
        Object.values(west).map((obj, index) => {
          checkArray.push(obj);
        })
        Object.values(south).map((obj, index) => {
          checkArray.push(obj);
        })
        return checkArray.includes("--");
      }
      function myOptionFunction(northGraph, southGraph, eastGraph, westGraph, dateTimeArray) {
        let rotateVal = dateTimeArray.length >= 24 ? 45 : 0;
        setmyOptions({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              show: false,
              type: 'none'
            },
            textStyle: {
              fontSize: 10,
            }
          },
          title: {
            text: 'Entering Volumes',
            bottom: '20px',
            left: '45%',
            textStyle: {
              fontSize: 12,
              fontFamily: 'Inter-Medium',
              fontStyle: 'normal',
              fontWeight: 500,            
              lineHeight: 16
            }
          },
          legend: {
            orient: 'horizontal',
            data: ['NB', 'SB', 'EB', 'WB'],
            bottom: '0px',
            textStyle: {
              fontSize: 10,
            }
          },
          grid: {
            bottom: '90px',
            height: 'auto',
            top: '20px',
            left: '40px',
            right: '15px',
          },
          xAxis: {
            axisLabel: {
              rotate: rotateVal,   
              fontSize: 10,
              interval: 0
            },
            type: 'category',
            data: dateTimeArray,
            splitLine: {
              show: true,
              lineStyle: {              
                color: '#F4F4F5',              
                width: 1
              }
            },
            axisLine : {
              show : false
            },
            axisTick : {
              show : false
            }
          },
          yAxis: {
            type: 'value',      
            splitLine: {
              show: true,
              lineStyle: {              
                color: '#F4F4F5',              
                width: 1
              }
            },
            axisLine : {
              show : false
            },
            axisTick : {
              show : false
            },
            axisLabel: {
              fontSize:  10,
            },
          },
          series: [
            {
              name: 'NB',
              type: 'bar',
              itemStyle: {
                color: "#3B82F6",
                width:'35px'
              },         
              stack: 'five',
              label: {
                show: false,
                position: 'insideRight'
              },
              data: northGraph,
            },
            {
              name: 'SB',
              type: 'bar',
              itemStyle: {
                color: "#10B981",
                width:'35px'
              },         
              stack: 'five',
              label: {
                show: false,
                position: 'insideRight'
              },
              data: southGraph,
            },
            {
              name: 'EB',
              type: 'bar',
              itemStyle: {
                color: "#F59E0B",
                width:'35px'
              },         
              stack: 'five',
              label: {
                show: false,
                position: 'insideRight'
              },
              data: eastGraph,
            },
            {
              name: 'WB',
              type: 'bar',
              itemStyle: {
                color: "#F87171",
                width:'35px'
              },         
              stack: 'five',
              label: {
                show: false,
                position: 'insideRight'
              },
              data: westGraph,
            },
          ]
        })
      }    
      const homeEvent = () => { // event to go at initial view
    
      }
      const ZoomInEvent = () => { // event to zoom in map
        zoom.zoomIn();
    
      }
      const zoomOutEvent = () => { // event to zoom out map
        zoom.zoomOut();
      }  
    const peakHSummComponent = () => {
        return(
          <>        
          <Grid item xs={8}>                
                  <Select                  
                      className="select-dp slc-time-perido-details"              
                      id="demo-simple-select"   
                      value={selectedDate}
                      height='38px'                               
                      style={{width:'248px'}}
                      onChange={(e) => onDateChange(e)}
                      IconComponent={ExpandMoreIcon}
                      MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                  >                      
                      {(peakDate.length>0)?peakDate.map((val, index) => {
                          return <MenuItem value={val}>{val}</MenuItem>                        
                      })
                      :null}                                    
                  </Select>
          </Grid>
          <Grid item xs={4} style={{textAlign:'center',paddingLeft: '5px'}}>
                  <Select             
                      className="select-dp"   
                      id="demo-simple-select"
                      value={timePeriod} 
                      onChange={(e) => onTimePeriorodChange(e)}
                      height='38px'   
                      style={{width:'120px'}}   
                      IconComponent={ExpandMoreIcon}   
                      MenuProps={{PaperProps:{className:'slct-details-cmp'}}}                     
                  >
                  <MenuItem value='AM' disabled={amHasData}>AM</MenuItem>
                  <MenuItem value='MID' disabled={midHasData}>MID</MenuItem>                
                  <MenuItem value='PM'disabled={pmHasData}>PM</MenuItem>
                  </Select>
            </Grid>
        </>    
        )
      } 
      const peakInfoDetailsComponent = () => {
        return (
          <Grid container className='info-count-pn'>
                <Grid item style={{minWidth:'109px'}}>
                  <label className='title-peak-hour'>{timePeriod} Peak hour</label>
                  <span className='time-peak-lb'>                
                  {(timePeriod=='AM')?(AMdata.hasOwnProperty('hour'))?(AMdata.hour.startdate+' - '+AMdata.hour.enddate):null:null}
                  {(timePeriod=='MID')?(MIDdata.hasOwnProperty('hour'))?(MIDdata.hour.startdate+' - '+MIDdata.hour.enddate):null:null}
                  {(timePeriod=='PM')?(PMdata.hasOwnProperty('hour'))?(PMdata.hour.startdate+' - '+PMdata.hour.enddate):null:null}
                  </span>    
                </Grid>
                <Grid item style={{minWidth:'109px',paddingLeft:'32px'}}>
                  <label className='title-peak-hour'>{timePeriod} Peak 15 min</label>   
                  <span className='time-peak-lb'>             
                  {(timePeriod=='AM')?(AMdata.hasOwnProperty('minute'))?(AMdata.minute.startdate+' - '+AMdata.minute.enddate):null:null}
                  {(timePeriod=='MID')?(MIDdata.hasOwnProperty('minute'))?(MIDdata.minute.startdate+' - '+MIDdata.minute.enddate):null:null}
                  {(timePeriod=='PM')?(PMdata.hasOwnProperty('minute'))?(PMdata.minute.startdate+' - '+PMdata.minute.enddate):null:null}
                  </span>   
                </Grid>
          </Grid>
        )
      }   
      const setExportData = () => {
        setSingleIntersectionStationId([{ station_id: stationData.station_id,
                     station_type: stationData.station_type, 
                     client_Station_Id: stationData.client_station_id, 
                     Station_location: stationData.station_location }]);
        
        exportpopUp();
        
      }
       /* This funtion is call for stored single Station station Id start*/
 
  /* This funtion is call for stored single station Id end*/
    const handleDeleteScenario = () => {
      let id = scenarioToDelete ? scenarioToDelete['scenario_id'] : null;
      if(id) {
        try {
          axios({
              method: 'delete',
              headers: {
                'payload': Cookies.get('payload'),
              },
              url: API_URL + API_PATH.deleteScenario+id,
          })
          .then(async function (response) {
                  if (response && response.status == '200') {
                    setReloadScenarios(true);
                    setShowDeleteScenario(false);
                  } 
              })
              .catch((err) => {
                  console.error(err);        
              })
        } catch (error) {
            console.error(error);
        }
      }
    }
    return (
        <div className='full-screen-main'>
            <div className='md-all-details'>
            <div className='md-header-details' style={{"max-width":'1328px', width: '100%'}}>
             <Tabs value={tabValue} onChange={handleChangeTab} className='tb-hd-main-opts' aria-label="basic tabs example">
              <Tab label="Station details" {...a11yProps(0)} />
              <Tab label="Traffic counts" {...a11yProps(1)} disabled={!hasData} />   
              <Tab label="Capacity planning" {...a11yProps(2)} />           
            </Tabs> 
            <div className='header-options-md'>
            <Button 
                className='btn-blue btn-export-data' 
                variant="contained" 
                disabled={!hasData}
                style={!hasData?{opacity:'0.5'}:{opacity:'1'}}
                onClick={() => setExportData() }
               > <img src={require('../../../assets/icons/File - Download.svg')} style={{marginRight:'10px'}}/>Export</Button>                      
            </div>            
             </div>
             <div className='md-body-details' style={{"max-width":'1328px', width: '100%'}}> 
             {sharedStation?<div className='tb-shared-info-mn'><Card className='tb-details-info tb-shared-info' style={{}}> 
                  <img src={require('../../../assets/icons/shared_icon.svg')}/>
                  <div className="tb-shared-info-lb">
                      <span>Shared</span>
                      <label>This station is shared from {sharedAgencyName}</label>
                  </div> 
                </Card></div>:null} 
              <TabPanel value={tabValue} index={0}>
                <div className='details-summary-map-files'>                
                  <div className='details-summary-map'>
                    <div className='details-summary'>
                      <div className='details-card'>
                        <label>Station</label>
                        <div className='md-body-card-details' style={{}}>
                        {stationData?<StationCard clss={!hasData?'details-main-info details-main-no-data':'details-main-info'} sharedStation={sharedStation} sharedAgencyName={sharedAgencyName} stationData={stationData} turningCountDate={turningCountDate} pedestrianCountDate={pedestrianCountDate} biCycleCountDate={biCycleCountDate}/>:null}
                        </div>
                      </div>                   
                      {(hasData)?<div className='details-card'>
                        <label>Details</label>   
                        <div style={{}}>                   
                          <DetailsCard stationData={stationData}/>                     
                        </div>
                      </div>:<NoDetails stationData={stationData}/>}
                      {(hasData && stationData.miscellaneous)?
                        <div className='details-card' style={{marginTop: '16px', width: '376px'}}>
                          <label className='info-sub-title'>Miscellaneous</label>
                          <Card className='info-details-miscellaneous'>
                            {stationData.miscellaneous}
                          </Card>
                        </div>
                      :null}                     
                    </div>
                    <div className='details-map'>
                      <label>Map</label>  
                      {/*hasData?<div className='disabled-map' style={{height: '90%'}}></div>:null*/}
                      <div ref={mapRef} className={!hasData?'map-details-pn map-details-no-data':'map-details-pn'} data-testid='mapView' style={!hasData?{opacity:'1'}:{}, hasData && stationData.miscellaneous ? {height: '444px'} : {}}></div>
                      <Box display='flex' flexDirection="column" className="homeIconList" style={!hasData?{opacity:'1'}:{}}>
                        {/* <div data-testid="homeBtn" className="homeIcon" title="Home">
                          <HomeIcon onClick={() => homeEvent()} title="Home" />
                        </div>                         */}
                        <div data-testid="zoomInBtn" className="zoomIcon" style={{ marginBottom: '-3px' }} title="Zoom In">
                          <AddIcon onClick={() => ZoomInEvent()} title="Zoom In" />
                        </div>
                        <div data-testid="zoomOutBtn" className="inIcon" title="Zoom Out">
                          <RemoveIcon onClick={() => zoomOutEvent()} title="Zoom Out" />
                        </div>
                      </Box>
                    </div>
                  </div>  
                  <div className='tb-list-files-act'>
                      <Card className='card-file-list'>
                        <FileList list={stationList} getFileList={getFileList} fullscreen={true} stationData={stationData} sharedStation={sharedStation}/> 
                      </Card>
                  </div>
                </div>    
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <div className='details-traffic-count'>
                  <div className='tc-card'>
                    <label>Station</label>
                    <div className='md-body-card-details'>
                      <StationCard sharedStation={sharedStation} sharedAgencyName={sharedAgencyName} stationData={stationData} turningCountDate={turningCountDate} pedestrianCountDate={pedestrianCountDate} biCycleCountDate={biCycleCountDate}/>
                    </div>
                  </div>  
                  <div className='tc-card' style={{margin:'0px 16px'}}>
                    <label>Count date & time</label>
                    <Card className='details-main-info details-date-time' style={{width:'100%'}}>
                        <Grid container>
                          <Grid item xs={12} className='opt-details-peak-hour'>
                            {peakHSummComponent()}
                          </Grid>
                        </Grid>
                    </Card>
                  </div>
                  <div className='tc-card'>
                    <label>Peak hours</label>
                    <Card className='details-main-info details-peak-hour-dt2' style={{width:'100%'}}>
                        <Grid container>
                          <Grid item xs={12}>
                            {peakInfoDetailsComponent()} 
                          </Grid>
                        </Grid>
                    </Card>
                  </div>
                </div>
                <div className='details-tf-study'>
                  <div className='details-tf-study-card' style={{marginRight:'16px'}}>
                    <label>Turning movements</label>
                    <Card className='details-main-info-img'>
                      <div className='intersection-counts-pn' style={{textAlign:'center'}}>
                      {(showLoader)?<div className='loader-details-progress top-280'>
                        <div className={'loader'}></div>
                      </div>:null } 
                      <div className='sb-approach' style={{ margin: "15px 0px -10px 0px" }}>
                        <span>{sb_approach}</span>
                      </div>
                        <div style={{width:'608px',height:'608px',position:'relative',left:'50%',marginLeft:'-304px',opacity: showLoader?'50%':'100%', display: "flex", "flex-direction": "column"}}>
                          <img src={turingImgSrc} style={{ width: "100%"}} />  
                          <Turning turningCountData={turningCountData} positions={{left:285, top:240}}/>
                        <div style={{ display: 'flex', height: '100%', width: "100%", "align-items": "center", position: "absolute" }}>
                          <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(270deg)" }}>
                            <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                              <span>{eb_approach}</span>
                            </div>
                          </div>
                          <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(90deg)" }}>
                            <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                              <span>{wb_approach}</span>
                            </div>
                          </div>
                        </div>
                        </div>
                      <div className='nb-approach' style={{ margin: "-15px 0px 10px 0px" }}>
                        <span>{nb_approach}</span>
                      </div>
                      </div>
                    </Card>
                  </div>
                  <div className='details-tf-study-card'>
                    <label>Truck percentages</label>
                    <Card className='details-main-info-img'>
                      <div className='intersection-counts-pn' style={{textAlign:'center'}}>
                      {(showLoader)?<div className='loader-details-progress top-280'>
                        <div className={'loader'}></div>
                      </div>:null } 
                      <div className='sb-approach' style={{ margin: "15px 0px -10px 0px" }}>
                        <span>{sb_approach}</span>
                      </div>
                        <div style={{width:'608px',height:'608px',position:'relative',left:'50%',marginLeft:'-304px',opacity: showLoader?'50%':'100%', display: "flex", "flex-direction": "column"}}>
                          <img src={trackImage} style={{ width: "100%"}} />  
                          <Trunk truckCountData={truckCountData}/>
                        <div style={{ display: 'flex', height: '100%', width: "100%", "align-items": "center", position: "absolute" }}>
                          <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(270deg)" }}>
                            <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                              <span>{eb_approach}</span>
                            </div>
                          </div>
                          <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(90deg)" }}>
                            <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                              <span>{wb_approach}</span>
                            </div>
                          </div>
                        </div>
                        </div>
                      <div className='nb-approach' style={{ margin: "-15px 0px 10px 0px" }}>
                        <span>{nb_approach}</span>
                      </div>
                      </div>
                    </Card>
                  </div>
                </div>
                <div className='details-tf-study'>
                  <div className='details-tf-study-card' style={{marginRight:'16px'}}>
                    <label>Pedestrian volumes</label>
                    <Card className='details-main-info-img'>
                      <div className='intersection-counts-pn' style={{textAlign:'center'}}>
                      {(showLoader)?<div className='loader-details-progress top-280'>
                        <div className={'loader'}></div>
                      </div>:null } 
                      <div className='sb-approach' style={{ margin: "15px 0px -10px 0px" }}>
                        <span>{sb_approach}</span>
                      </div>
                        <div style={{width:'608px',height:'608px',position:'relative',left:'50%',marginLeft:'-304px',opacity: showLoader?'50%':'100%', display: "flex", "flex-direction": "column"}}>
                          <img src={pedestrianImage} style={{ width: "100%"}} />  
                          <Pedestrian pedestrianData={pedestrianData}/>
                        <div style={{ display: 'flex', height: '100%', width: "100%", "align-items": "center", position: "absolute" }}>
                          <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(270deg)" }}>
                            <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                              <span>{eb_approach}</span>
                            </div>
                          </div>
                          <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(90deg)" }}>
                            <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                              <span>{wb_approach}</span>
                            </div>
                          </div>
                        </div>
                        </div>
                      <div className='nb-approach' style={{ margin: "-15px 0px 10px 0px" }}>
                        <span>{nb_approach}</span>
                      </div>
                      </div>
                    </Card>
                  </div>
                  <div className='details-tf-study-card'>
                    <label>Bicycle movements</label>
                    <Card className='details-main-info-img'>
                      <div className='intersection-counts-pn' style={{textAlign:'center'}}>
                      {(showLoader)?<div className='loader-details-progress top-280'>
                        <div className={'loader'}></div>
                      </div>:null } 
                      <div className='sb-approach' style={{ margin: "15px 0px -10px 0px" }}>
                        <span>{sb_approach}</span>
                      </div>
                        <div style={{width:'608px',height:'608px',position:'relative',left:'50%',marginLeft:'-304px',opacity: showLoader?'50%':'100%', display: "flex", "flex-direction": "column"}}>
                          <img src={bicycleImage} style={{ width: "100%"}} />  
                          <img src={pedestrianImage} style={{ width: "100%"}} /> 
                          <Cycle bicycleCountData={bicycleCountData} bicycleCrosswalkCountData={bicycleCrosswalkCountData}/>
                        <div style={{ display: 'flex', height: '100%', width: "100%", "align-items": "center", position: "absolute" }}>
                          <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(270deg)" }}>
                            <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                              <span>{eb_approach}</span>
                            </div>
                          </div>
                          <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(90deg)" }}>
                            <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                              <span>{wb_approach}</span>
                            </div>
                          </div>
                        </div>
                        </div>
                      <div className='nb-approach' style={{ margin: "-15px 0px 10px 0px" }}>
                        <span>{nb_approach}</span>
                      </div>
                      </div>
                    </Card>
                  </div>
                </div>  
                <div className='details-tf-chart'>
                  <label>Traffic counts by approach</label>
                  {(showLoader)?<div className='loader-details-progress '>
                        <div className={'loader'}></div>
                      </div>:null } 
                  <Card style={{opacity: showLoader?'50%':'100%'}}>                      
                    {myOptions && JSON.stringify(getResponseData) != "{}" ? <ReactEcharts option={myOptions} style={{ height: '560px' }} /> :
                      <div style={{padding:'10px'}}><NoDetails/></div>}
                  </Card>
                </div>    
                <div className='details-tf-table'>
                  <label>Data displayed for all vehicles</label>
                  <DataVehicles 
                    getResponseApproches={getResponseApproches}
                    getResponseData={getResponseData}
                    startPeakHour={startPeakHour}
                    endPeakHour={endPeakHour}
                    startPeakMin={startPeakMin}
                    endPeakMin={endPeakMin}
                    getDashedArray={getDashedArray}
                  />
                </div>
              </TabPanel> 
              <TabPanel value={tabValue} index={2} dir={theme.direction}>  
                <SignalPlanning 
                  hasData={hasData} 
                  sharedStation={sharedStation}
                  sharedAgencyName={sharedAgencyName}
                  stationData={stationData}
                  turningCountDate={turningCountDate} 
                  pedestrianCountDate={pedestrianCountDate} 
                  biCycleCountDate={biCycleCountDate}
                  setShowNewScenario={setShowNewScenario}
                  reloadScenarios={reloadScenarios}
                  setReloadScenarios={setReloadScenarios}
                  peakData={peakData}
                  setShowDeleteScenario={setShowDeleteScenario}
                  newScenarioId={newScenarioId}
                  setNewScenarioId={setNewScenarioId}
                  setScenarioToDelete={setScenarioToDelete}
                  setShowLaneConfig={setShowLaneConfig}
                />
              </TabPanel>              
             </div>
            </div>
            {exportChecked == 'block' ?
         <div className="exportDataPanel" style={{ display: exportChecked }}>
           <ExportDataDetails 
             checkExportValue={exportpopUp} 
             groupStations={singleIntersectionStationId} />
         </div>
         : null}
          <HelpDisk /> 
          {
            showNewScenario &&
            <CreateScenario 
              setShowNewScenario={setShowNewScenario} 
              showNewScenario={showNewScenario} 
              setReloadScenarios={setReloadScenarios}
              stationData={stationData}
              setNewScenarioId={setNewScenarioId}
            />
          }
          {
            showDeleteScenario &&
            <DeleteScenario 
              showDeleteScenario={showDeleteScenario}
              setShowDeleteScenario={setShowDeleteScenario}
              scenarioToDelete={scenarioToDelete}
              handleDeleteScenario={handleDeleteScenario}
            />
          }
          {
            showLaneConfig &&
            <LaneGeometry 
              showLaneConfig={showLaneConfig}
              setShowLaneConfig={setShowLaneConfig}
              readOnly={true}
              lat={stationData.latitude}
              long={stationData.longitude}
              stationType={stationData.station_type}
              approachesForLane={[{eb_approach:stationData.eb_approach}, {nb_approach:stationData.nb_approach}, {sb_approach:stationData.sb_approach}, {wb_approach:stationData.wb_approach}]}
            />
          }
        </div>
       
    )
}

export default FullScreen;
